import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "m15 11.252 1.5 1.5.75-.75V8.76l2.276-.61a3 3 0 1 0-3.675-3.675l-.61 2.277H12l-.75.75 1.5 1.5m2.25 2.25-8.47 8.47c-.34.34-.8.53-1.28.53s-.94.191-1.28.53l-.97.97-.75-.75.97-.97c.34-.339.53-.8.53-1.28s.19-.94.53-1.28l8.47-8.47m2.25 2.25-2.25-2.25"
    }, null, -1)
  ])))
}
export default { render: render }